/*
 * サブシステム名：XXXX
 * 機能名：一般経費一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

const DdSearchList = () => import('@/components/DdSearchList')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'PrmIppanKeihiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdTextBox,
    DdDateRangeBox,
    DdRadioButton
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,

    conditions: {
      sagyoStartYmdString: '',
      sagyoEndYmdString: '',
      keijoStartYmdString: '',
      keijoEndYmdString: '',
      sagyoJissekiNo: '',
      jissekiTorokuZumiFlgKbn: null,
      jissekiShimeFlgKbn: null,
      hasseiYmdFromTo: null,
      keijoYmdFromTo: null,
      jissekiTorokuZumiFlgKbnNm: null,
      jissekiShimeFlgKbnNm: null
    },
    conditionDetails: [
      { key: 'hasseiYmdFromTo', name: '発生年月日', value: 'hasseiYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'keijoYmdFromTo', name: '計上年月日', value: 'keijoYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'sagyoJissekiNo', name: '一般経費No', value: 'sagyoJissekiNo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'jissekiTorokuZumiFlgKbnNm', name: '実績確認状況', value: 'jissekiTorokuZumiFlgKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'jissekiShimeFlgKbnNm', name: '実績締状況', value: 'jissekiShimeFlgKbnNm', type: 'value', delete: false, showValue: true, convertValue: false }
    ],
    modeKengen: 0
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 発生年月日
    'conditions.sagyoStartYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoStartYmdString) ? this.conditions.sagyoStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoEndYmdString) ? '～' + this.conditions.sagyoEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    'conditions.sagyoEndYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.sagyoStartYmdString) ? this.conditions.sagyoStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.sagyoEndYmdString) ? '～' + this.conditions.sagyoEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    // 計上年月日
    'conditions.keijoStartYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    },
    'conditions.keijoEndYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    },
    // 実績登録状況
    'conditions.jissekiTorokuZumiFlgKbn': function (n) {
      this.conditions.jissekiTorokuZumiFlgKbnNm = this.conditions.jissekiTorokuZumiFlgKbn === '1' ? '済' : this.conditions.jissekiTorokuZumiFlgKbn === '0' ? '未' : '全て'
    },
    // 実績確認状況
    'conditions.jissekiShimeFlgKbn': function (n) {
      this.conditions.jissekiShimeFlgKbnNm = this.conditions.jissekiShimeFlgKbn === '1' ? '済' : this.conditions.jissekiShimeFlgKbn === '0' ? '未' : '全て'
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.sagyoYmdDisp = elem.sagyoYmd ? filter.dateFormatter(elem.sagyoYmd) : ''
        elem.keijoYmdDisp = elem.keijoYmd ? filter.dateFormatter(elem.keijoYmd) : ''
        elem.suryoDisp = elem.suryo === 0 || elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTankaDisp = elem.keihiTanka === 0 || elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.keihiKingakuDisp = elem.keihiKingaku === 0 || elem.keihiKingaku ? filter.numericFormatter(elem.keihiKingaku) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmIppanKeihiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '一般経費No', value: 'sagyoJissekiNo' },
              { text: '発生年月日', value: 'sagyoYmdDisp', align: 'center' },
              { text: '計上年月日', value: 'keijoYmdDisp', align: 'center' },
              { text: '実績確認済み', value: 'jissekiTorokuZumiFlgDisp' },
              { text: '実績締', value: 'jissekiShimeFlgDisp' },
              { text: '取引先', value: 'torihikisakiNm' },
              { text: '入力担当者', value: 'nyuryokuTantoshaNm' },
              { text: '経費営業所', value: 'keihiEigyoshoNm' },
              { text: '経費部門', value: 'keihiBumonNm' },
              { text: '一般経費区分', value: 'ippanSeibiKeihiKbnNm' },
              { text: '数量', value: 'suryoDisp', align: 'right' },
              { text: '一般経費単位区分', value: 'ippanSeibiTaniKbnNm' },
              { text: '経費単価', value: 'keihiTankaDisp', align: 'right' },
              { text: '経費金額', value: 'keihiKingakuDisp', align: 'right' },
              { text: '摘要', value: 'tekiyo' },
              { text: '社内備考', value: 'shanaiBiko' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              sagyoStartYmdString: '',
              sagyoEndYmdString: '',
              keijoStartYmdString: '',
              keijoEndYmdString: '',
              sagyoJissekiNo: '',
              jissekiTorokuZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmIppanKeihiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('PrmIppanKeihiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmIppanKeihiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmIppanKeihiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmIppanKeihiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd2110/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              sagyoStartYmdString: '',
              sagyoEndYmdString: '',
              keijoStartYmdString: '',
              keijoEndYmdString: '',
              sagyoJissekiNo: '',
              jissekiTorokuZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9'
            }
            self.searchText = ''
            self.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (this.conditions.sagyoStartYmdString && this.conditions.sagyoEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.sagyoStartYmdString, this.conditions.sagyoEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.sagyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.sagyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.keijoStartYmdString && this.conditions.keijoEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.keijoStartYmdString, this.conditions.keijoEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.keijoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.keijoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
